import {
    SET_DATE_FILTER, SET_UTIL_DATE, SET_PROD_DATE, SET_HEALTH_DATE, SET_TIER_DATE, SET_TRENDS_DATE, SET_OPERATIONS_DATE, SET_IMC_DATE, SET_KOWA_DATE, SET_REPORTING_DATE, SET_REPORTMINING_DATE
} from './types';
import moment from "moment";

const initialLocationDates = {
    locationDates: {
        startDate: moment().subtract(180, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    },
    utilizationDates: {
        startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    },
    healthDates: {
        startDate: moment().subtract(180, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    },
    productivityDates: {
        startDate: moment().subtract(180, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    },
    tierDates: {
        startDate: moment().subtract(180, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    },
    trendsDates: {
        startDate: moment().subtract(180, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    },
    operationsDates: {
        startDate: moment().subtract(180, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    },
    imcDates: {
        startDate: moment().subtract(180, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    },
      kowaDates: {
          startDate: moment().subtract(365, "days").format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD') 
    },
    reportingDates: {
        startDate: moment().subtract(180, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    },
   reportMiningDates: {
        startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    }
};

const reducers = (state = initialLocationDates, action: any) => {
    switch (action.type) {
        case SET_DATE_FILTER: {
            
            let locationDates = state?.locationDates ?? initialLocationDates;
            locationDates = { ...locationDates, ...action.locationDates };
            return {
                ...state, locationDates
            };
        }
        case SET_UTIL_DATE: {
            let utilizationDates = state?.utilizationDates ?? initialLocationDates;
            utilizationDates = { ...utilizationDates, ...action.utilizationDates };
            return {
                ...state, utilizationDates
            };
        }
        case SET_PROD_DATE: {
            let productivityDates = state?.productivityDates ?? initialLocationDates;
            productivityDates = { ...productivityDates, ...action.productivityDates };
            return {
                ...state, productivityDates
            };
        }
        case SET_HEALTH_DATE: {
            let healthDates = state?.healthDates ?? initialLocationDates;
            healthDates = { ...healthDates, ...action.healthDates };
            return {
                ...state, healthDates
            };
        }
        case SET_TIER_DATE: {
            let tierDates = state?.tierDates ?? initialLocationDates;
            tierDates = { ...tierDates, ...action.tierDates };
            return {
                ...state, tierDates
            };
        }
        case SET_TRENDS_DATE: {
            let trendsDates = state?.trendsDates ?? initialLocationDates;
            trendsDates = { ...trendsDates, ...action.trendsDates };
            return {
                ...state, trendsDates
            };
        }
        case SET_OPERATIONS_DATE: {
            let operationsDates = state?.operationsDates ?? initialLocationDates;
            operationsDates = { ...operationsDates, ...action.operationsDates };
            return {
                ...state, operationsDates
            };
        }
        case SET_IMC_DATE: {
            let imcDates = state?.imcDates ?? initialLocationDates;
            imcDates = { ...imcDates, ...action.imcDates };
            return {
                ...state, imcDates
            };
        }
        case SET_KOWA_DATE: {
            let kowaDates = state?.kowaDates ?? initialLocationDates;
            kowaDates = { ...kowaDates, ...action.kowaDates };
            return {
                ...state, kowaDates
            };
        }

        case SET_REPORTING_DATE: {
            let reportingDates = state?.reportingDates ?? initialLocationDates;
            reportingDates = { ...reportingDates, ...action.reportingDates };
            return {
                ...state, reportingDates
            };
        }

        case SET_REPORTMINING_DATE: {
            let reportMiningDates = state?.reportMiningDates ?? initialLocationDates;
            reportMiningDates = { ...reportMiningDates, ...action.reportMiningDates };
            return {
                ...state, reportMiningDates
            };
        }
        default:
            return state;
    }
};

export default reducers;




